import { PermissionProp } from '../../permission/store/actionType';
export enum actionTypes {
  //FETCH ROLE
  FETCH_ROLES_REQUEST = "FETCH_ROLES_REQUEST",
  FETCH_ROLES_SUCCESS = "FETCH_ROLES_SUCCESS",
  FETCH_ROLES_FAIL = "FETCH_ROLES_FAIL",
  //create role
  CREATE_ROLE_REQUEST = "CREATE_ROLE_REQUEST",
  CREATE_ROLE_SUCCESS = "CREATE_ROLE_SUCCESS",
  CREATE_ROLE_FAIL = "CREATE_ROLE_FAIL",
  //Update role
  UPDATE_ROLE_REQUEST = "UPDATE_ROLE_REQUEST",
  UPDATE_ROLE_SUCCESS = "UPDATE_ROLE_SUCCESS",
  UPDATE_ROLE_FAIL = "UPDATE_ROLE_FAIL",
  //delete role
  DELETE_ROLE_REQUEST = "DELETE_ROLE_REQUEST",
  DELETE_ROLE_SUCCESS = "DELETE_ROLE_SUCCESS",
  DELETE_ROLE_FAIL = "DELETE_ROLE_FAIL",
}

export interface GenericAuthStateProps {
  isLoading: boolean;
  status: stateStatusType | null;
  error: string | null;
}

export enum stateStatusType {
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
}

export interface RoleProps {
  description: string;
  id: string;
  name: string;
  permissions: PermissionProp[];
  
}
export interface CreateRoleInput {
  description: string;
  name: string;
}
export interface RoleError {
  description?: string;
  name?: string;
}
export interface UpdateRoleInput {
  name: string;
  description: string;
  id: string;
}

export interface RolePaylodProps {
  role: RoleProps;
}
//FETCH RILE
export interface FetchRolesRequestAction {
  type: actionTypes.FETCH_ROLES_REQUEST;
}

export interface FetchRolesSuccessAction {
  type: actionTypes.FETCH_ROLES_SUCCESS;
  payload: RolePaylodProps[];
}

export interface FetchRolesFailureAction {
  type: actionTypes.FETCH_ROLES_FAIL;
  payload: string;
}
//CREATE ROLE
export interface CreateRoleRequestAction {
  type: actionTypes.CREATE_ROLE_REQUEST;
}

export interface CreateRoleSuccessAction {
  type: actionTypes.CREATE_ROLE_SUCCESS;
  payload: RoleProps;
}

export interface CreateRoleFailureAction {
  type: actionTypes.CREATE_ROLE_FAIL;
  payload: string;
}
//update ROLE
export interface UpdateRoleRequestAction {
  type: actionTypes.UPDATE_ROLE_REQUEST;
}

export interface UpdateRoleSuccessAction {
  type: actionTypes.UPDATE_ROLE_SUCCESS;
  payload: RoleProps;
}

export interface UpdateRoleFailureAction {
  type: actionTypes.UPDATE_ROLE_FAIL;
  payload: string;
}
//delete ROLE
export interface DeleteRoleRequestAction {
  type: actionTypes.DELETE_ROLE_REQUEST;
}

export interface DeleteRoleSuccessAction {
  type: actionTypes.DELETE_ROLE_SUCCESS;
  payload: string;
}

export interface DeleteRoleFailureAction {
  type: actionTypes.DELETE_ROLE_FAIL;
  payload: string;
}

export type RoleActions =
  | FetchRolesRequestAction
  | FetchRolesSuccessAction
  | FetchRolesFailureAction
  | CreateRoleRequestAction
  | CreateRoleSuccessAction
  | CreateRoleFailureAction
  | UpdateRoleRequestAction
  | UpdateRoleSuccessAction
  | UpdateRoleFailureAction
  | DeleteRoleRequestAction
  | DeleteRoleSuccessAction
  | DeleteRoleFailureAction;
